import FullNameLink from './FullNameLink'
export default FullNameLink
